// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditLanguage {
    width: 100%;
}

.editLanguageContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 20px;
    width: 100%;
}

.editLanguageCard {
    width: 90%;
    background-color: #0E1B1B;
    border: 1px solid #1E2D2D;
    border-radius: 14px;
    padding: 22px 28px;
    display: flex;
    flex-direction: column;
    gap: 14px;
    box-sizing: border-box;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
}

.editLanguageLabel {
    color: #839696;
    font-family: "Inter", sans-serif;
    font-size: 13.5px;
    font-weight: 500;
    letter-spacing: 0.2px;
}

.languageDropdownContainer {
    position: relative;
    width: 100%;
}

.languageSelectInput {
    width: 100%;
    min-height: 52px;
    background-color: #142424;
    border: 1px solid #233737;
    border-radius: 12px;
    padding: 8px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    box-sizing: border-box;
    transition: all 0.2s ease;
    gap: 12px;
}

.languageSelectInput:hover {
    border-color: #4DCBCA;
}

.languagePlaceholder {
    color: #7A7A7A;
    font-family: "Inter", sans-serif;
    font-size: 15px;
}

.selectedLanguageTags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
    flex: 1 1;
}

/* Premium dark teal pill chip */
.languageChip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: rgba(90, 175, 154, 0.14);
    border: 1px solid rgba(90, 175, 154, 0.35);
    border-radius: 20px;
    padding: 4px 10px 4px 12px;
    color: #FFFFFF;
    font-family: "Inter", sans-serif;
    font-size: 13.5px;
    font-weight: 500;
    transition: all 0.15s ease;
}

.languageChip:hover {
    background: rgba(90, 175, 154, 0.22);
    border-color: #5AAF9A;
}

.languageChipText {
    color: #E6F7F4;
    line-height: 1.2;
}

.languageChipRemoveBtn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    color: #839696;
    background-color: transparent;
    cursor: pointer;
    transition: all 0.15s ease;
}

.languageChipRemoveBtn:hover {
    color: #FFFFFF;
    background-color: rgba(239, 68, 68, 0.7);
}

.languageArrowIcon {
    color: #5AAF9A;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: color 0.2s ease;
    flex-shrink: 0;
}

.languageSelectInput:hover .languageArrowIcon {
    color: #4DCBCA;
}

.languageDropdownMenu {
    position: absolute;
    top: calc(100% + 6px);
    left: 0;
    width: 100%;
    background-color: #0E1B1B;
    border: 1px solid #1E2D2D;
    border-radius: 12px;
    box-shadow: 0 12px 36px rgba(0, 0, 0, 0.7);
    list-style: none;
    padding: 8px;
    margin: 0;
    z-index: 1000;
    max-height: 240px;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: thin;
    scrollbar-color: #5AAF9A #0E1B1B;
    box-sizing: border-box;
}

.languageDropdownItem {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 14px;
    color: #FFFFFF;
    cursor: pointer;
    border-radius: 8px;
    font-family: "Inter", sans-serif;
    font-size: 14.5px;
    font-weight: 500;
    transition: all 0.15s ease;
}

.languageDropdownItem:hover {
    background-color: #142424;
    color: #4DCBCA;
}

.languageDropdownItem.selected {
    color: #5AAF9A;
    background-color: rgba(90, 175, 154, 0.1);
}

.languageSelectedCheck {
    color: #5AAF9A;
    font-weight: 700;
    font-size: 14px;
}

.languageErrorText {
    color: #FF5252;
    font-family: "Inter", sans-serif;
    font-size: 12.5px;
    margin-top: 4px;
}

.editLanguageSubmitBtnContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 90%;
    margin-top: 10px;
}

.editLanguageSubmitBtn {
    width: 100%;
    height: 48px;
    background-color: #5AAF9A;
    color: #0E1B1B;
    border: none;
    border-radius: 12px;
    font-family: "Inter", sans-serif;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    box-shadow: 0 4px 14px rgba(90, 175, 154, 0.25);
}

.editLanguageSubmitBtn:hover:not(:disabled) {
    background-color: #4DCBCA;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(77, 203, 202, 0.35);
}

.editLanguageSubmitBtn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

@media (max-width: 768px) {
    .editLanguageCard,
    .editLanguageSubmitBtnContainer {
        width: 95%;
        padding: 18px 20px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Components/EditLanguage/EditLanguage.css"],"names":[],"mappings":"AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,UAAU;IACV,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,sBAAsB;IACtB,0CAA0C;AAC9C;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,sBAAsB;IACtB,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,mBAAmB;IACnB,SAAO;AACX;;AAEA,gCAAgC;AAChC;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,oCAAoC;IACpC,0CAA0C;IAC1C,mBAAmB;IACnB,0BAA0B;IAC1B,cAAc;IACd,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,6BAA6B;IAC7B,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;IACP,WAAW;IACX,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,0CAA0C;IAC1C,gBAAgB;IAChB,YAAY;IACZ,SAAS;IACT,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,+CAA+C;AACnD;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI;;QAEI,UAAU;QACV,kBAAkB;IACtB;AACJ","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap\");\n\n.EditLanguage {\n    width: 100%;\n}\n\n.editLanguageContainer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    gap: 20px;\n    width: 100%;\n}\n\n.editLanguageCard {\n    width: 90%;\n    background-color: #0E1B1B;\n    border: 1px solid #1E2D2D;\n    border-radius: 14px;\n    padding: 22px 28px;\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n    box-sizing: border-box;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);\n}\n\n.editLanguageLabel {\n    color: #839696;\n    font-family: \"Inter\", sans-serif;\n    font-size: 13.5px;\n    font-weight: 500;\n    letter-spacing: 0.2px;\n}\n\n.languageDropdownContainer {\n    position: relative;\n    width: 100%;\n}\n\n.languageSelectInput {\n    width: 100%;\n    min-height: 52px;\n    background-color: #142424;\n    border: 1px solid #233737;\n    border-radius: 12px;\n    padding: 8px 16px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    cursor: pointer;\n    box-sizing: border-box;\n    transition: all 0.2s ease;\n    gap: 12px;\n}\n\n.languageSelectInput:hover {\n    border-color: #4DCBCA;\n}\n\n.languagePlaceholder {\n    color: #7A7A7A;\n    font-family: \"Inter\", sans-serif;\n    font-size: 15px;\n}\n\n.selectedLanguageTags {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    align-items: center;\n    flex: 1;\n}\n\n/* Premium dark teal pill chip */\n.languageChip {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    background: rgba(90, 175, 154, 0.14);\n    border: 1px solid rgba(90, 175, 154, 0.35);\n    border-radius: 20px;\n    padding: 4px 10px 4px 12px;\n    color: #FFFFFF;\n    font-family: \"Inter\", sans-serif;\n    font-size: 13.5px;\n    font-weight: 500;\n    transition: all 0.15s ease;\n}\n\n.languageChip:hover {\n    background: rgba(90, 175, 154, 0.22);\n    border-color: #5AAF9A;\n}\n\n.languageChipText {\n    color: #E6F7F4;\n    line-height: 1.2;\n}\n\n.languageChipRemoveBtn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 18px;\n    height: 18px;\n    border-radius: 50%;\n    color: #839696;\n    background-color: transparent;\n    cursor: pointer;\n    transition: all 0.15s ease;\n}\n\n.languageChipRemoveBtn:hover {\n    color: #FFFFFF;\n    background-color: rgba(239, 68, 68, 0.7);\n}\n\n.languageArrowIcon {\n    color: #5AAF9A;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: color 0.2s ease;\n    flex-shrink: 0;\n}\n\n.languageSelectInput:hover .languageArrowIcon {\n    color: #4DCBCA;\n}\n\n.languageDropdownMenu {\n    position: absolute;\n    top: calc(100% + 6px);\n    left: 0;\n    width: 100%;\n    background-color: #0E1B1B;\n    border: 1px solid #1E2D2D;\n    border-radius: 12px;\n    box-shadow: 0 12px 36px rgba(0, 0, 0, 0.7);\n    list-style: none;\n    padding: 8px;\n    margin: 0;\n    z-index: 1000;\n    max-height: 240px;\n    overflow-y: auto;\n    overflow-x: hidden;\n    scrollbar-width: thin;\n    scrollbar-color: #5AAF9A #0E1B1B;\n    box-sizing: border-box;\n}\n\n.languageDropdownItem {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 10px 14px;\n    color: #FFFFFF;\n    cursor: pointer;\n    border-radius: 8px;\n    font-family: \"Inter\", sans-serif;\n    font-size: 14.5px;\n    font-weight: 500;\n    transition: all 0.15s ease;\n}\n\n.languageDropdownItem:hover {\n    background-color: #142424;\n    color: #4DCBCA;\n}\n\n.languageDropdownItem.selected {\n    color: #5AAF9A;\n    background-color: rgba(90, 175, 154, 0.1);\n}\n\n.languageSelectedCheck {\n    color: #5AAF9A;\n    font-weight: 700;\n    font-size: 14px;\n}\n\n.languageErrorText {\n    color: #FF5252;\n    font-family: \"Inter\", sans-serif;\n    font-size: 12.5px;\n    margin-top: 4px;\n}\n\n.editLanguageSubmitBtnContainer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 90%;\n    margin-top: 10px;\n}\n\n.editLanguageSubmitBtn {\n    width: 100%;\n    height: 48px;\n    background-color: #5AAF9A;\n    color: #0E1B1B;\n    border: none;\n    border-radius: 12px;\n    font-family: \"Inter\", sans-serif;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s ease;\n    box-shadow: 0 4px 14px rgba(90, 175, 154, 0.25);\n}\n\n.editLanguageSubmitBtn:hover:not(:disabled) {\n    background-color: #4DCBCA;\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(77, 203, 202, 0.35);\n}\n\n.editLanguageSubmitBtn:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n@media (max-width: 768px) {\n    .editLanguageCard,\n    .editLanguageSubmitBtnContainer {\n        width: 95%;\n        padding: 18px 20px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
